import { err, ok, type Result } from "./result";

declare const emailAddressBrand: unique symbol;

export type EmailAddress = string & { readonly [emailAddressBrand]: "EmailAddress" };

export type EmailAddressParseError =
  | { readonly kind: "missingEmail" }
  | { readonly kind: "invalidEmail" };

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const normalizeEmailAddress = (value: string): string =>
  value.trim().toLowerCase();

export const parseOptionalEmailAddress = (
  value: string | null | undefined,
): Result<EmailAddress | null, EmailAddressParseError> => {
  const normalized = normalizeEmailAddress(value ?? "");
  if (normalized === "") return ok(null);
  return EMAIL_PATTERN.test(normalized)
    ? ok(normalized as EmailAddress)
    : err({ kind: "invalidEmail" });
};

export const parseEmailAddress = (value: string): Result<EmailAddress, EmailAddressParseError> => {
  const normalized = normalizeEmailAddress(value);
  if (normalized === "") return err({ kind: "missingEmail" });
  return EMAIL_PATTERN.test(normalized)
    ? ok(normalized as EmailAddress)
    : err({ kind: "invalidEmail" });
};

export const normalizedEmailOrNull = (value: string | null | undefined): EmailAddress | null => {
  const parsed = parseOptionalEmailAddress(value);
  return parsed.ok ? parsed.value : null;
};
